import { AppState } from '../../data/state'
import { store } from '../../store/store'
import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { IFunnelTrackingData } from './models/IFunnelTrackingData'
import { getFunnelRequiredDetails } from './utils'

export function productDetailPage() {
  try {
    const metrics = getMetrics()
    metrics.api.track(EventTypes.PRODUCT_DETAILS_PAGE, getProductDetails())
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}

function getProductDetails(): IFunnelTrackingData {
  const state: AppState = Object.assign({}, store.getState())

  return getFunnelRequiredDetails(state)
}

export function FacebookProductDetails(data: IFunnelTrackingData) {
  return {
    value: data.total_value,
    currency: data.currency,
    content_id: data.trip_id,
    content_name: data.trip_type,
    content_category: data.category,
    trip_type: data.trip_type,
    departure_date: data.departure_date,
    people: data.people,
    adults: data.adults,
    children: data.children,
    babies: data.people,
    country: data.country,
  }
}

export function GoogleProductDetails(data: IFunnelTrackingData) {
  return {
    items: [
      {
        id: data.trip_id,
        name: data.trip_type,
        category: data.category,
        price: data.total_value,
        quantity: 1,
        dimension1: data.trip_type,
        dimension2: data.departure_date,
        dimension3: data.people,
        dimension6: data.adults,
        dimension7: data.children,
        dimension8: data.babies,
        dimension9: data.destination,
        dimension10: data.departure_airport,
        dimension11: data.departure_time,
        dimension12: data.accomodation,
        dimension13: data.days,
        dimension17: data.country,
      },
    ],
    currency: data.currency,
  }
}

export function SnapchatProductDetails(data: IFunnelTrackingData): any {
  return {
    price: data.total_value,
    currency: data.currency,
    item_ids: [data.trip_id],
    item_category: data.category,
  }
}
